module.exports = __webpack_public_path__ + "static/media/case2.fd7a4c3d.jpg";